import React from 'react';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar'
import './signin.css';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Tooltip from '@mui/material/Tooltip';
import Alert from '@mui/material/Alert';



const PREFIX = 'SigninForm';

const classes = {
    margin: `${PREFIX}-margin`,
    dialog: `${PREFIX}-dialog`
};

const StyledThemeProvider = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.margin}`]: {
        margin: theme.spacing(1),
    }
}));



function SigninForm(props) {
    const {
        username,
        password,
        confirmPassword,
        onChangeField,
        onLogin,
        alert,
        alertMessage,
        alertType,
        closeAlert,
        getButton,
        theme,
        onKeyPress,
        errorPassword,
        errorPasswordMessage,
        errorPasswordConfirmation,
        errorPasswordMessageConfirmation,
        openNewUser,
        handleCloseDialog,
        onChangeFieldNewUser,
        changePasswordButtonDisabled,
    } = props;


    return (
        <StyledThemeProvider theme={theme}>
            <div className="Inicio">
                <div className="Imagen__Inicio">
                    {/*<img src={fondo} alt=""></img>*/}
                </div>
                <div className="Inicio__Form">

                    <div className="FormCenter">
                        <div className="FormTitle">
                            <Typography variant="h6">ClasS Statistics</Typography>
                        </div>

                        {/*Componente de alerta*/}
                        <Snackbar
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={alert}
                            autoHideDuration={5000}
                            onClose={closeAlert}
                        >
                            <Alert onClose={closeAlert} severity={alertType}>
                                {alertMessage}
                            </Alert>
                        </Snackbar>

                        {/*Componente de diálogo para cambio de contraseña*/}
                        <Dialog
                            open={openNewUser}
                            onClose={(event, reason) => {
                                //the panel only closes agter pressing registrar (or after reloading the page)
                            }}
                            aria-labelledby="form-dialog-title"
                            sx={{margin: '100px'}}
                            disableEscapeKeyDown
                        >
                            <DialogTitle id="form-dialog-title">Nuevo usuario</DialogTitle>
                            <DialogContent dividers>
                                <DialogContentText>
                                    Por favor ingresa una nueva contraseña.
                                </DialogContentText>
                                <div className="FormField__Label">
                                    <TextField
                                        error={errorPassword}
                                        helperText={errorPasswordMessage}
                                        label="Nueva contraseña"
                                        placeholder="Ingresa nueva contraseña"
                                        type="password"
                                        fullWidth
                                        color="secondary"
                                        variant="standard"
                                        value={password}
                                        onChange={e => onChangeFieldNewUser('password', e.target.value)}
                                    />
                                </div>
                                <div className="FormField__Label">
                                    <TextField
                                        error={errorPasswordConfirmation}
                                        helperText={errorPasswordMessageConfirmation}
                                        label="Confirma nueva contraseña"
                                        placeholder="Confirma nueva contraseña"
                                        type="password"
                                        fullWidth
                                        color="secondary"
                                        variant="standard"
                                        value={confirmPassword}
                                        onChange={e => onChangeFieldNewUser('confirmPassword', e.target.value)}
                                    />
                                </div>
                            </DialogContent>
                            <DialogActions>
                                {!changePasswordButtonDisabled ?
                                    <Button disabled={changePasswordButtonDisabled} onClick={handleCloseDialog} color="primary">
                                        Registrar
                                    </Button>
                                    :
                                    <Tooltip title="Debes completar ambos campos de contraseña">
                                        <span>
                                            <Button disabled={changePasswordButtonDisabled} onClick={handleCloseDialog} color="primary">
                                                Registrar
                                            </Button>
                                        </span>
                                    </Tooltip>
                                }
                            </DialogActions>
                        </Dialog>

                        {/* Campos para login */}
                        <div className="FormField__Label">
                            <TextField
                                label="Nombre de usuario"
                                placeholder="Ingresa tu nombre de usuario"
                                fullWidth
                                value={username}
                                color="primary"
                                variant="standard"
                                onChange={e => onChangeField('username', e.target.value)}
                            />
                        </div>
                        <div className="FormField__Label">
                            <TextField
                                label="Contraseña"
                                placeholder="Ingresa tu contraseña"
                                type="password"
                                fullWidth
                                color="primary"
                                variant="standard"
                                value={password}
                                onChange={e => onChangeField('password', e.target.value)}
                            />
                        </div>
                        <div className="FormField__Button">
                            {getButton()}
                        </div>
                    </div>

                </div>
            </div>
        </StyledThemeProvider>
    );
}

export default SigninForm;